export const MAIN = "/";
export const HOME = "home";
export const ABOUT = "about";
export const MENU = "menu";
export const BOOKING_FORM = "/booking-form";
export const ORDER_ONLINE = "/order-online";
export const CONFIRMED = "/booking-form/confirmed";
export const LOGIN = "/login";
